/*
* Resideo/LifeWhere
* Copyright (C) 2018-2023 Resideo/LifeWhere
* mailto:nathan.williams@resideo.com
*/

import http from "../http-common";

const controller = "/Feedback";
class UserFeedbackService 
{
    async postUserFeedback(feedbackData, customerId, partnerId , assetId) 
    {
        const response = await http.post(`${controller}/postuserfeedback?partnerId=${partnerId}&customerId=${customerId}&assetId=${assetId}`, feedbackData);
        return response.data;
    }
    async getFeedbackTableData( partnerId)
    {
        const response = await http.get(`${controller}/getfeedbacktabledata?partnerId=${partnerId}`);
        return response.data;
    }
}

export default new UserFeedbackService();